import { render } from "./pieChart.vue?vue&type=template&id=3f8bf16c&scoped=true&ts=true"
import script from "./pieChart.vue?vue&type=script&lang=ts"
export * from "./pieChart.vue?vue&type=script&lang=ts"

import "./pieChart.vue?vue&type=style&index=0&id=3f8bf16c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f8bf16c"]])

export default __exports__